import moment from 'moment';
import { Box, H3, HR, Panel, Text } from '@bigcommerce/big-design';
import { ORDER_ACTIONS } from '../hooks/useOrderEditState';
import './History.css';
import { Notes } from './Notes';

function getLogMessageDate(message) {
	const [time] = message.split(']');
	const formattedTime = time.replace('[', '');
	const momentTime = moment(formattedTime);

	return momentTime.toDate();
}

function formatLogMessage(message) {
	const [time, body] = message.split(']');
	const formattedTime = time.replace('[', '');

	return `${moment(formattedTime).format('MMM Do YYYY')} at ${moment(
		formattedTime,
	).format('LT')} - ${body}`;
}

function logMessageSorter(
	{ message: leftLogMessage },
	{ message: rightLogMessage },
) {
	return (
		getLogMessageDate(rightLogMessage).getTime() -
		getLogMessageDate(leftLogMessage).getTime()
	);
}

export default function History({ logs, orderDispatch }) {
	return (
		<Panel marginTop="Large" header="History">
			<Box marginTop="Large">
				<Notes
					onAddNote={(note) =>
						orderDispatch({
							type: ORDER_ACTIONS.ADD_NOTE,
							data: note,
						})
					}
				/>
				<Box marginLeft="medium">
					<H3>Order Change Log</H3>
					<Box marginTop="Large">
						{logs
							.sort(logMessageSorter)
							.map(({ message }, index) => (
								<Box key={index}>
									<div className="message">
										<Text
											className={'george'}
											marginBottom="none"
										>
											{formatLogMessage(message)}
										</Text>
										<HR marginVertical="large" />
									</div>
								</Box>
							))}
					</Box>
				</Box>
			</Box>
		</Panel>
	);
}
